import { Step, StepLabel, Stepper } from "@mui/material";

const steps = [
      'Asignando taller',
      'Esperando Unidad',
      'Trabajando unidad',
      'unidad finalizada'
];
export function TimeLineOrdenComponent({select}){
      return (
            <Stepper activeStep={select} alternativeLabel>
                  {steps.map((label) => (
                        <Step key={label}>
                              <StepLabel>{label}</StepLabel>
                        </Step>
                  ))}
            </Stepper>
      );
}